/**
 * Open PDF from S3 CDN URL in a new window/tab.
 *
 * PDFs are served directly from CloudFront/S3 bucket.
 *
 * @param downloadUrl - CDN URL to the PDF file (e.g., https://findcare-dev.uhc.com/cdn/assets/...)
 * @param filename - Optional filename to set as the browser tab title
 */
export const openPdfFromUrl = (
  downloadUrl?: string,
  filename?: string
): void => {
  if (!downloadUrl) {
    throw new Error('Download URL is required to open PDF');
  }

  const pdfWindow = window.open(downloadUrl, '_blank');

  if (pdfWindow && filename) {
    try {
      pdfWindow.document.title = filename;
    } catch {}
  }
};
